// All TV management requests, including multipart chunks, use the current session.
export async function tvUploadRequest(url, options = {}) {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('Veuillez vous reconnecter avant de gérer les vidéos.');
    const headers = new Headers(options.headers);
    headers.set('Authorization', `Bearer ${token}`);
    const response = await fetch(url, { ...options, headers, cache: 'no-store' });
    const isJson = response.headers.get('content-type')?.includes('application/json');
    const data = isJson ? await response.json() : null;
    if (response.status === 401) {
        throw new Error('Votre session a expiré ou a été refusée. Reconnectez-vous puis relancez le téléversement.');
    }
    if (!response.ok || data?.success === false) {
        throw new Error(data?.message || `Erreur HTTP ${response.status} lors de la gestion vidéo.`);
    }
    if (!data) throw new Error("Le serveur n'a pas renvoyé de JSON valide.");
    return data;
}
